import {
  UPDATE_EXAMINATION_SUBMISSION_USE_CASE,
  UpdateExaminationSubmissionUseCase,
  IExaminationSubmissionRepository,
  EXAMINATION_SUBMISSION_REPOSITORY,
  BAN_EXAMINATION_SUBMISSION_USE_CASE,
  BanExaminationSubmissionUseCase,
  CLOSE_EXAMINATION_SUBMISSION_USE_CASE,
  CloseExaminationSubmissionUseCase,
} from '@module/assignment';

export const examinationSubmissionUseCaseProviders = [
  {
    provide: CLOSE_EXAMINATION_SUBMISSION_USE_CASE,
    useFactory: (repository: IExaminationSubmissionRepository) =>
      new CloseExaminationSubmissionUseCase(repository),
    inject: [EXAMINATION_SUBMISSION_REPOSITORY],
  },
  {
    provide: UPDATE_EXAMINATION_SUBMISSION_USE_CASE,
    useFactory: (examinationSubmissionRepository: IExaminationSubmissionRepository) => {
      return new UpdateExaminationSubmissionUseCase(examinationSubmissionRepository);
    },
    inject: [EXAMINATION_SUBMISSION_REPOSITORY],
  },
  {
    provide: BAN_EXAMINATION_SUBMISSION_USE_CASE,
    useFactory: (examinationSubmissionRepository: IExaminationSubmissionRepository) => {
      return new BanExaminationSubmissionUseCase(examinationSubmissionRepository);
    },
    inject: [EXAMINATION_SUBMISSION_REPOSITORY],
  },
];
